import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import dayjs from "dayjs";
import { selectMainStrategy } from "../../../../Redux/Reducers/strategyStoreSlice";
import MetricCard from "./MetricCard";

const formatDate = (date) => dayjs(date).format("MMM D, YYYY");

const StrategyMetrics = () => {
  const mainStrategy = useSelector(selectMainStrategy);

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid size={{ xs: 12, sm: 3 }}>
        <MetricCard
          title="Backtest Period"
          value={`${formatDate(mainStrategy?.startDate)} to ${formatDate(mainStrategy?.endDate)}`}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <MetricCard
          title="Period Return"
          value={`${((mainStrategy?.periodReturn ?? 0)).toFixed(2)}%`}
          color={mainStrategy?.periodReturn >= 0 ? "success.main" : "error.main"}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <MetricCard
          title="Sharpe Ratio"
          value={(mainStrategy?.sharpeRatio ?? 0).toFixed(4)}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <MetricCard
          title="Max Drawdown"
          value={`${((mainStrategy?.maxDrawdown ?? 0)).toFixed(2)}%`}
          color={mainStrategy?.maxDrawdown >= 0 ? "success.main" : "error.main"}
        />
      </Grid>
    </Grid>
  );
};

export default StrategyMetrics;
